import { render } from "./ActAssignmentsMockup.vue?vue&type=template&id=602d9fbe&scoped=true"
import script from "./ActAssignmentsMockup.vue?vue&type=script&lang=js"
export * from "./ActAssignmentsMockup.vue?vue&type=script&lang=js"

import "./ActAssignmentsMockup.vue?vue&type=style&index=0&id=602d9fbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602d9fbe"]])

export default __exports__